import { render, staticRenderFns } from "./MaterialLabel.vue?vue&type=template&id=527d04bb&scoped=true&"
import script from "./MaterialLabel.vue?vue&type=script&lang=js&"
export * from "./MaterialLabel.vue?vue&type=script&lang=js&"
import style0 from "./MaterialLabel.vue?vue&type=style&index=0&id=527d04bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527d04bb",
  null
  
)

export default component.exports